import LatticeIcon from './LatticeIcon'

export default LatticeIcon
